__turbopack_context__.v({
  "base": "GlassCard-module__vzxJqW__base",
  "glassCard": "GlassCard-module__vzxJqW__glassCard" + " " + "GlassCard-module__vzxJqW__base",
  "glassCardContent": "GlassCard-module__vzxJqW__glassCardContent",
  "glassCardHover": "GlassCard-module__vzxJqW__glassCardHover",
  "heroStatsCard": "GlassCard-module__vzxJqW__heroStatsCard" + " " + "GlassCard-module__vzxJqW__base",
});
